<template>
  <div>
    <headers>
    </headers>
      <div class='search_banner'>
          <div class="search_box">
            <input type="text" v-model="searchData" @keyup.enter="search_submit(searchData)" placeholder="请输入你的问题">
            <div class="search_icon" @click="search_submit(searchData)"></div>
          </div>
      </div>
      <div class="menus">
        <div class="menus_box">
          <!-- <pre>{{menusCurId}}</pre> -->
          <router-link class="menus_a " :class="menusCurId==id_item.categoryId ? 'cur' : ''" :key="'id'+id_index" v-for='(id_item,id_index) in categoryList' :to="'/hc/categories/'+id_item.categoryId">{{id_item.categoryName}}</router-link>
        </div>
      </div>
<!-- <pre>{{navigationList}}</pre> -->
      <div class="main_list clearfix">
        <ul class="main_list_left" >
            <li  :class="navCurId==hot_item.categoryId ? 'cur' : ''" :key="'index2'+index2" v-for='(hot_item,index2) in navigationList' @click="articleListData(hot_item.categoryId,hot_item.categoryName)">
              <span>{{hot_item.categoryName}}</span>
            </li>
        </ul>
        <ul class="main_right">
            <li v-show='listData.length>0' :key='index' v-for='(item,index) in listData'>
              <span>{{item.updateTime}}</span>
              <router-link class="list" :to="'/detail/'+item.id+'?type='+'1'">{{item.title}}</router-link>
            </li>
            <li v-show='hotList.length>0' :key="'listIndex'+index1" v-for='(list_item,index1) in hotList'>
              <router-link class="list" :to="'/detail/'+list_item.id+'?type='+'2'">{{list_item.title}}</router-link>
            </li>
        </ul>
      </div>
      <footerHtml></footerHtml>
  </div>
</template>
<script>
import headers from '../components/headers.vue'
import footerHtml from '../components/footer_html.vue'
import {
  getCategoryList,
  getHotList,
  getArticleList} from '@/axios'
export default {
  name: 'articles',
  components: {
    headers,
    footerHtml
  },
  data () {
    return {
      searchData:"",
      menusId:0,//区分获取几级菜单，0是第一请求获取一级菜单
      menusType:0,//用于区分判断 一级列表页刷新的初始状态
      menusCurId:0,//用于获取当前选中一级标签的ID
      menus_name:"",
      nav_name:"",
      // navHotCur:true,
      // navHotType:false,
      navType:0,//用于区分判断 一级列表页刷新的初始状态
      navCur:false,//二级
      navCurId:0,
      secondaryMenu:[],
      categoryList:[],
      listData:[],
      hotList:[],
      menusAttryID:0,
      navigationList:[]
    }
  },
   created(){
        this.menusAttryID=this.$route.params.id;
        this.categoryListData();

    },
  methods:{
    search_submit(){
        this.$router.push({path:'/hc/search',query: {id:this.searchData}})
    },
    async categoryListData() {
      // console.log(this.menusAttryID);
      let route_name = this.$route.name;
      // let listNav=JSON.parse(localStorage.getItem('menusAttry'));
      // console.log(listNav);
      
      // this.menusId=this.$route.params.id;
      if(this.menusType==0 ){
          this.menusId=0;
      }else if (route_name == 'index' || this.menusType==0){
            this.menusId=this.menusCurId;
            this.menusAttryID=this.categoryList[0].categoryId;
      }else{
          this.menusId=this.menusAttryID;
      }
      // console.log(this.menusId)
       const res = await getCategoryList({
          parentId:this.menusId
        })
          let _D = res.data;
        if (_D.code == 22000) {
            if(route_name == 'index' && this.menusType==0){
              this.menusId=0;
              this.categoryList=_D.result;
              this.menusType=2;
              this.menusCurId=_D.result[0].categoryId;
              // localStorage.setItem('menusAttry', JSON.stringify(_D.result))
              this.categoryListData()
            }else if(route_name == 'categories' && this.menusType==0){
              this.menusType=2;

              // console.log(_D.result);


              this.categoryList=_D.result;
              let curId=this.$route.params.id;
              
              let _this=this;
              this.categoryList.forEach(function (item,index,array) {
                  if(item.categoryId==curId){
                   _this.menusId=curId;
                   _this.menusCurId=curId;
                  }else{
                      _this.menusId=_this.categoryList[0].categoryId;
                      // _this.menusCurId=_this.categoryList[0].categoryId;
                      _this.$route.params.id=_this.categoryList[0].categoryId;
                      // _this.$router.push({
                      //   params: _this.$merge(_this.$route.params, { id:_this.categoryList[0].categoryId }),
                      // });
                      _this.$router.push({path:'/hc/categories',params: {id:_this.categoryList[0].categoryId}})
                      // console.log("a");
                  }
                  
              });

              this.categoryListData()
            } else{
              this.menusId=this.$route.params.id;
              this.secondaryMenu=_D.result;
              if(this.secondaryMenu[0]){
                  this.navCurId=this.secondaryMenu[0].categoryId;
              }
              this.hotListData(this.menusCurId);

            }
        }
    },
    async hotListData(id,name) {
      this.listData=[];
      this.hotList=[];
      let menus_id=this.menusId;
         const res = await getHotList({
            categoryId:this.menusAttryID
          })
          let _D = res.data;
          if(_D.code == 22000){
            if(_D.result.length==0){
              if(this.secondaryMenu[0]){
                this.articleListData( this.secondaryMenu[0].categoryId);
                this.navigationList=this.secondaryMenu;
                this.navCurId=this.navigationList[0].categoryId;
              }
            }else{
              this.hotList=res.data.result;
              this.navigationList=this.secondaryMenu;
              // console.log(this.menusId);
              if(name!='热门问题' && this.menusType!=0){
                this.navigationList.splice(0,0,{categoryId: this.menusCurId, categoryName: "热门问题"});
              }
              this.navCurId=this.navigationList[0].categoryId;
              this.MenusTitle(this.categoryList);
              document.title = this.menus_name+"-"+'热门问题-列表'
            }
          }
    },
    articleListData(id,name) {
      this.listData=[];
      this.hotList=[];
      this.navCurId=id;
      this.navHotCur=false;
      if(name=='热门问题'){
        this.hotListData(id,name);
      }else{
        getArticleList({
            categoryId:id
        }).then(res => {
          let _D = res;
          if(_D.code == 22000){
              this.listData=res.result;
              this.MenusTitle(this.categoryList);
              this.navTitle(this.secondaryMenu);
              document.title = this.menus_name+"-"+this.nav_name+'-列表';
          }
        })
      }

    },
    MenusTitle(data) {
      this.categoryList.forEach((num, index) => {
        if(this.menusCurId==num.categoryId){
          this.menus_name=num.categoryName;
        }
      });
    },
    navTitle(data) {
      this.secondaryMenu.forEach((num, index) => {
        if(this.navCurId==num.categoryId){
          this.nav_name=num.categoryName
        }
      });
    }
  },
  watch:{
    $route(to,from){
      this.menusCurId=to.params.id;
      this.menusAttryID=to.params.id;
      this.categoryListData();
      this.navigationList=[];
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .search_banner{
    min-width: 1200px;
    height: 120px;
    background: url("./../assets/icon-beijing.png") no-repeat top center;
    background-size: cover;
    overflow: hidden;
  }
  .search_box{
    margin-top:40px;
    width: 600px;
    height:40px;
    margin:40px auto 0;
    background: #FFFFFF;
    border-radius: 26px;
    input::-webkit-input-placeholder{
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #AAACAD;
      line-height: normal;
      line-height: 22px\9;
    }
    input{
      height:16px;
      width: 500px;
      padding:12px 20px;
      line-height: 16px;
      font-size: 16px;
      color: #515457;
      border-top-left-radius: 26px;
      border-bottom-left-radius: 26px;
      border:none;
      background: none;
      font-family: PingFangSC-Regular;
      outline: none;
      float: left;
    }
    .search_icon{
      float:right;
      width: 60px;
      height: 40px;
      border-radius: 0 26px 26px 0;
      background: #056EFB url("./../assets/icon-dasouuo.png") no-repeat 15px 6px;
      background-size: 30px 30px;
      cursor: pointer;
    }
  }
  .menus{
    min-width: 1200px;
    height: 100px;
    background: #F4F4F5;
    overflow: hidden;
    .menus_box{
      width: 1200px;
      margin: 30px auto;
      vertical-align: top;
      text-align: center;
      .menus_a{
          font-family: PingFangSC-Light;
          width: 112px;
          height: 40px;
          line-height: 40px;
          margin:0 20px;
          text-align: center;
          display: inline-block;
          background: #FFFFFF;
          border-radius: 2px;
          font-size: 16px;
          color: #202428;
      }
      .menus_a.cur{
          background: #056EFB;
          color: #FFFFFF;
          font-family: PingFangSC-Regular;
      }
    }
  }
  .main_list{
    width: 1200px;
    margin: 0 auto;
  }
  .main_list_left{
    padding-top:40px;
    border-right: 1px solid#F4F4F5;
    width:200px;
    float: left;
    height: 600px;
    overflow-y:auto;
    li{
      height:24px;
      // overflow: hidden;
      line-height: 24px;
      padding-left: 16px;
      margin-bottom:30px;
      position: relative;
      padding-right:10px;
      font-size: 16px;
      color: #202428;
      // text-overflow:ellipsis;
      // white-space:nowrap;
      cursor: pointer;
      // font-family: PingFangSC-Medium;
      font-family: PingFangSC-Regular;
       span{
          display: block;
          width: 100%;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
          font-family: PingFangSC-Light;
          font-size: 16px;
          color: #202428;
        }

    }
    .cur span{
      font-size: 16px;
      color: #056EFB;
      font-family: PingFangSC-Medium;
    }
    .cur::after{
      content: '';
      display: block;
      width: 4px;
      height: 16px;
      background: #056EFB;
      position: absolute;
      border-radius: 1.5px;
      left: 0px;
      top: 4px;
      z-index: 44;
    }
    // li:hover::before ,li:hover div{
    //   display: block;
    // }
  }
  .main_right{
    padding:42px 90px 6px 50px;
    height: 592px;
    overflow-y:auto;
    margin-left:200px;
    li{
      position: relative;
      top:0px;
      left:0px;
      z-index: 44;
      margin-bottom:24px;
      padding-left:22px;
      .list{
        // margin-right:186px;
        // height: 22px;
        display: block;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        width: 710px;
        color: #515457;
        letter-spacing: 0;
        line-height: 22px;
        // text-overflow:ellipsis;
        // white-space:nowrap;
        cursor: pointer;
        overflow: hidden;
      }
      .list:hover{
       color: #056EFB ;
      }
      span{
        display: block;
        text-align: right;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #AAACAD;
        letter-spacing: 0;
        line-height: 20px;
        float: right;
      }
    }
    li::after{
        content: '';
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 4px;
        background: #E4E4E5;
        position: absolute;
        border-radius: 4px;
        left: 0px;
        top: 9px;
        z-index: 44;
      }
  }
</style>



// WEBPACK FOOTER //
// src/hc/categories.vue